'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'star-half';
var width = 576;
var height = 512;
var aliases = [61731];
var unicode = 'f089';
var svgPathData = ['M116.7 227.4l93-16.1 20.2-3.5 11.4-17 22.7-33.7 0 241.5-82.7 35.5 14.2-98.8L199 312l-16.4-16.9-65.8-67.7z', 'M148.1 328.5L129.7 456.3l-8 55.7 51.7-22.2 138.7-59.6 0-344.3 0-85.9-48 71.2L201.6 164 76.2 185.7l-57.3 9.9 40.5 41.7 88.7 91.2zM116.7 227.4l93-16.1 20.2-3.5 11.4-17 22.7-33.7 0 241.5-82.7 35.5 14.2-98.8L199 312l-16.4-16.9-65.8-67.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalf = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;